export default "__VITE_ASSET__CdRt8u_M__"